import { useEffect, useState } from "react";
import {
  faEllipsisVertical,
  faGear,
  faFile,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Dropdown,
  Nav,
  Container,
  Table,
  Modal,
  Form,
} from "react-bootstrap";
import { data, useNavigate } from "react-router-dom";
import {
  DeleteRequest,
  GetRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useGetRequest } from "../../Utils/hooks/QueryHandler";
import { Pagination } from "../../pages/Pagination";
import DeleteModal from "../DeleteModal";
import { toast } from "sonner";
import "./InvoiceOrder.css";
import nodata from "../../Utils/assets/img/leads_no_data_found.png";
import { formatDate, formatToINR } from "../../Utils/helpers/commonhelper";
import { TableSkeleton } from "../../Utils/skeletonLoader/TableSkeleton";
import { AuthorizationCard } from "../../pages/AuthorizationCard";
import { baseURL } from "../../Utils/constants/constant";
import { ColumnConfigurator } from "../../pages/ColumnConfigurator";

export const PaymentReceviedOrder = () => {
  const navigate = useNavigate();

  const [customer, setCustomer] = useLocalStorageState("customer");

  const customer_id = customer?.customer_details?.customer_id || 1;
  const token = customer?.token?.authorization || "";
  const rf = customer?.token?.authentication || "";
  const extras = { customer, setCustomer, rf, navigate };
  const headers = {
    Authorization: token,
    Authentication: rf,
  };

  const [isMyApproval, setMyApproval] = useState(false);
  const [allSalesOrder, setAllSalesOrder] = useState([]);
  const [salesOrderId, setsalesOrderId] = useState();
  const [departmentToDelete, setDepartmentToDelete] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState([]);

  const [tempColumns, setTempColumns] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  // States for using pagination
  // Calculate total pages

  const [limit, setLimit] = useState(5);
  const [offset, setOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [inputSearch, setInputSearch] = useState("");
  const invoice_id = "1";
  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim());
      setOffset(0);
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [inputSearch]);
  const params = {
    limit,
    offset,
    search: search,
  };


  // poermissions for payment received 
  const permission = customer.customer_details?.permission;
  const isPaymentReceived = permission?.find(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "payment")
  const paymentReceivedPermission = permission?.filter(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "payment")
  const user_type = Number(customer.customer_details?.user_type)
  const paymentGrant = {
    isView: user_type !== 1 ? Boolean(Number(isPaymentReceived && paymentReceivedPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "payment")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(isPaymentReceived && paymentReceivedPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "payment")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(isPaymentReceived && paymentReceivedPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "payment")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(isPaymentReceived && paymentReceivedPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "payment")?.delete)) : true,
  }

  const endPoint = isMyApproval
    ? `/sales/fetchMyApprovals/${customer_id}/${customer?.customer_details?.id}`
    : `/sales/fetchAllOrders/${customer_id}`;

  const {
    data: salesOrderData,
    error,
    refetch: fetchSalesOrder,
    isLoading,
    isError,
  } = useGetRequest(
    `/invoice/fetchPayments/${customer_id}`,
    "getInvoiceOrder",
    headers,
    extras,
    params
  );

  useEffect(() => {
    fetchSalesOrder();
    setAllSalesOrder([]); // Reset before setting new data

    if (salesOrderData?.status === "success") {
      setAllSalesOrder(salesOrderData.data);
    } else if (salesOrderData?.status === "fail") {
      setAllSalesOrder([]);
    } else if (isError) {
      console.error("Error fetching quotation:", error);
    }
  }, [salesOrderData]);

  const pageCount = Math.ceil(salesOrderData?.total_count / limit) || 0;

  const [editData, setEditData] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isClone, setIsClone] = useState(false);

  const handleEditClick = async (id) => {
    if (!id) return;
    try {
      const res = await GetRequest(
        `/sales/fetchDetailsOfSpecificOrder/${id}`,
        { headers },
        extras
      );
      if (res.status === "success") {
        const editDataToSet = res.data;
        setEditData(editDataToSet);
        setIsEditOpen(true);
        setIsClone(false);
        setsalesOrderId(id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [toCancelQuotation, setToCancelQuotation] = useState();
  const [rejectReason, setRejectReason] = useState("");
  const [paymentToDelete, setPaymentToDelete] = useState(null);

  const handleCloseModal = () => {
    setShowModal(false);
    setRejectReason("");
    setLoading(false);
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const payload = {
        quotation_id: toCancelQuotation,
        customer_id: customer_id,
        canceletion_reason: rejectReason,
        user_login_id: customer?.customer_details?.id,
      };
      const res = await PutRequest(
        `quotation/cancelQuotation`,
        payload,
        { headers },
        extras
      );

      if (!res || res.status === "fail") {
        return toast.error(res.message || "something went wrong");
      }
      if (res.status === "success") {
        toast.success(res.message);
        setToCancelQuotation();
        setRejectReason("");
        await fetchSalesOrder();
        setShowModal(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowModal(false);
      setLoading(false);
    }
  };

  const handleCloneClick = async (id) => {
    if (!id) return;
    try {
      const res = await GetRequest(
        `/quotation/fetchDataOfSpecificQuotation/${id}/${customer_id}`,
        { headers },
        extras
      );
      if (res.status === "success") {
        const cloneDataToSet = res.data[0];
        setEditData(cloneDataToSet);
        setsalesOrderId(res.data[0].quotation_id);
        setIsEditOpen(true);
        setIsClone(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCloseEdit = () => {
    setEditData(null);
    setIsEditOpen(false);
    setIsClone(false);
  };
  // Handle page change from react-paginate
  const handlePageChange = (selectedItem) => {
    setOffset(selectedItem.selected);
  };

  const handleAddClick = (quotation) => {
    const dataToSend = {
      key1: quotation.quotation_id,
      key2: isMyApproval,
    };
  };

 const onDelete = (id) => {
     setPaymentToDelete(id);
     setShowDeleteModal(true);
   };
   const handleConfirmedDelete = async () => {
     try {
       const item = allSalesOrder.find((d) => d.payment_id === paymentToDelete);
       if (!item) return;
       setLoading(true);
 
       const res = await DeleteRequest(
         `invoice/deletePayment/${paymentToDelete}/${customer?.customer_details?.id}`,
         { headers },
         extras,
       );
 
       if (res?.status === "success") {
         toast.success(res.message);
         setAllSalesOrder([]);
         await fetchSalesOrder();
       } else {
         toast.error(res.message);
       }
     } catch (error) {
       console.error("Delete error:", error);
     } finally {
       setLoading(false);
       setShowDeleteModal(false);
       setPaymentToDelete(null);
     }
   };

  const columnOptions = [
    // { key: "sn", label: "#",locked: true },
    { key: "payment_number", label: "Payment Number", },
    { key: "invoice_number", label: "Invoice Number" },
    { key: "reference_number", label: "Reference Number" },
    { key: "account_type", label: "Account Type" },
    { key: "payment_mode", label: "Payment Mode" },
    { key: "amount_recieved", label: "Amount Received" },
    { key: "bank_charges", label: "Bank Charges" },
    { key: "payment_date", label: "Payment Date" },
    { key: "payment_recevied_on", label: "Payment Received On" },
    { key: "amount_deducted", label: "Amount Deducted" },
    { key: "tax_deducted", label: "Tax Deducted" },
    { key: "tds_tax_account", label: "TDS Tax Account" },
  ];
  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = localStorage.getItem("visiblePayReceivedColumns");
    const allColumnKeys = columnOptions.map(col => col.label);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    return allColumnKeys;
  });

  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message={"Are you sure you want to permanently delete this invoice?"}
      />
      <div className=" pb-1 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <h3
            className="mb-0 d-flex gap-2 align-items-center"
            style={
              isMyApproval
                ? { fontSize: 14, cursor: "pointer", color: '#4dabf4' }
                : {
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  fontSize: "22px",
                  cursor: "pointer",
                  color: "#4dabf4"
                }
            }
            onClick={() => setMyApproval(false)}
          >
            Payment Received
          </h3>
        </div>

        <div
          className="d-flex align-items-center gap-1"
          style={{
            height: "39px",
            position: "absolute",
            right: 0,
            top: "0.5rem",
          }}
        >
          {/* search bar */}
          <div className=" position-relative">
            <input
              type="text"
              style={{
                fontSize: "12px",
                paddingLeft: "36px",
                height: "35px",
              }}
              className="form-control "
              value={inputSearch}
              onChange={(e) => {
                setInputSearch(e.target.value);
                setOffset(0);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  setSearch(inputSearch);
                  setOffset(0);
                }
              }}
            />
            <i
              class="fa-solid fa-magnifying-glass"
              style={{
                position: "absolute",
                marginTop: "-26px",
                zIndex: 1,
                marginLeft: "13px",
              }}
            ></i>
            {inputSearch.length > 0 && (
              <i
                class="fa-solid fa-xmark"
                style={{
                  position: "absolute",
                  marginTop: "-26px",
                  zIndex: 1,
                  right: 0,
                  marginRight: "13px",
                  cursor: "pointer",
                }}
                onClick={() => setInputSearch("")}
              ></i>
            )}
          </div>

          <ColumnConfigurator
            columnOptions={columnOptions}
            columns={columns}
            setColumns={setColumns}
            storageKey="payReceivedColumns"
            visibleKey="visiblePayReceivedColumns"
          />

          {/* <Dropdown as="div" className="dropdownsWithoutToggle">
            <Dropdown.Toggle as={Nav.Link} className="header-link">
              <button
                className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                style={{
                  fontSize: "1rem",
                  alignItems: "center",
                  height: "35px",
                  width: "2.5rem",
                }}
              >
                <FontAwesomeIcon
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                  icon={faEllipsisVertical}
                />
              </button>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
              style={{ right: "3.4rem" }}
            >
              <Dropdown.Item href="#" className="d-flex align-items-center">
                {" "}
                Edit{" "}
              </Dropdown.Item>
              <Dropdown.Item href="#" className="d-flex align-items-center">
                {" "}
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
        </div>
      </div>
      {
        paymentGrant?.isView ?
          <Container
            fluid
            style={{
              fontFamily: "'Poppins', sans-serif",
              height: "calc(100vh - 14rem)",
              padding: 0,
              backgroundColor: "white",
              animation: "cardEntry 1s ease-out forwards",
            }}
            className="mt-3 p-0"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
              }}
            >


              <div
                className="listStyleForContact container-table"
                style={{
                  flex: allSalesOrder?.length > 10 ? 1 : "auto",
                  overflow: allSalesOrder?.length > 10 ? "auto" : "auto",
                  width: "100%",
                  maxHeight: allSalesOrder?.length > 10 ? "100%" : "auto",
                  scrollbarWidth: "thin"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.scrollbarColor = "#e0e0e0 white"

                }}
              >
                <Table
                  style={{
                    width: "100%",
                    tableLayout: "auto",
                    backgroundColor: "white",
                    marginBottom: "0px",
                    borderCollapse: "separate",
                    borderSpacing: "0px",
                  }}
                >
                  <thead style={{ zIndex: 101 }}>
                    <tr>
                      <th
                        className="text-start  pinned-column last-pinned-column  bulk-selection-cell customize-cell-width"
                        style={{
                          width: 60,
                          minWidth: 60,
                          maxWidth: 60,
                          left: 0,
                        }}
                      >
                        <span>#</span>
                      </th>
                      {/* <th className="text-start sortable" aria-sort="">
                        Payment Number
                      </th> */}
                      {columns.map((col, index) => (
                        <th
                          key={`header-${index}`}
                          style={{
                            textAlign:
                              col !== "Invoice Number" &&
                                col !== "Sales Number" &&
                                col !== "Customer Name" &&
                                col !== "Start Date"
                                ? "center"
                                : "left",
                          }}
                        >
                          {col}
                        </th>
                      ))}

                      <th className="text-start " style={{ padding: "0px 2px" }} aria-sort="">
                        Attachment
                      </th>
                      <th className="text-start " style={{minWidth : '2 rem'}}></th>
                    </tr>
                  </thead>

                  <tbody style={{ textAlign: "start" }}>
                    {isLoading ? (
                      <TableSkeleton columnCount={columns.length + 2} />
                    ) : (
                      <>
                        {allSalesOrder && allSalesOrder.length > 0 ? (
                          allSalesOrder.map((saleOrder, index) => (
                            <tr key={saleOrder?.id || index}>
                              <td>{offset * limit + index + 1}</td>
                              <td>{saleOrder.payment_number}</td>

                              {/* Dynamic cells based on columns order */}
                              {columns.map((col, cellIndex) => {
                                switch (col) {
                                  case "Invoice Number":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`}>
                                        {saleOrder.invoice_number}
                                      </td>
                                    );

                                  case "Reference Number":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`}>
                                        {saleOrder.reference_number}
                                      </td>
                                    );

                                  case "Account Type":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`}>
                                        {saleOrder.account_name}
                                      </td>
                                    );

                                  case "Payment Mode":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {saleOrder.payment_mode}
                                      </td>
                                    );

                                  case "Amount Received":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatToINR(saleOrder.amount_recevied || 0)}
                                      </td>
                                    );

                                  case "Bank Charges":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatToINR(saleOrder?.bank_charges || 0)}
                                      </td>
                                    );

                                  case "Payment Date":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`}>
                                        {formatDate(saleOrder?.payment_date)}
                                      </td>
                                    );

                                  case "Payment Received On":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatDate(saleOrder?.payment_recieved_on)}
                                      </td>
                                    );

                                  case "Amount Deducted":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatToINR(saleOrder?.amount_deducted || 0)}
                                      </td>
                                    );

                                  case "Tax Deducted":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {saleOrder?.tax_deducted}
                                      </td>
                                    );

                                  case "TDS Tax Account":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`}>
                                        {saleOrder?.tds_tax_account || "-"}
                                      </td>
                                    );

                                  default:
                                    return null;
                                }
                              })}

                              {/* Attachment column - always present */}
                              <td key={`attachment-${index}`} style={{ textAlign: "center" }}>
                                {saleOrder.attachment ? (
                                  <a
                                    href={`${baseURL}${saleOrder.attachment}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "none", color: "#007bff" }}
                                  >
                                    <FontAwesomeIcon
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        cursor: "pointer",
                                        color: "grey",
                                      }}
                                      icon={faFile}
                                    />
                                  </a>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td
                              className="text-center "
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                onDelete(saleOrder?.payment_id);
                              }}
                            >
                              {" "}
                              <FontAwesomeIcon
                                className="text-danger"
                                icon={faTrash}
                              />
                            </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={columns.length + 3} // +3 for #, payment_number, and attachment columns
                              style={{ textAlign: "center", color: "gray" }}
                            >
                              <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ padding: "2rem" }}
                              >
                                <img
                                  src={nodata}
                                  alt="No data found"
                                  style={{ width: "17rem" }}
                                />
                              </div>
                            </td>
                          </tr>
                        )}

                        {allSalesOrder?.length > 10 && (
                          <tr
                            className="no-hover-row"
                            style={{
                              backgroundColor: "#ffffff",
                              marginTop: "0px !important",
                              marginBottom: "0px !important",
                            }}
                          >
                            <td colSpan={columns.length + 3}>
                              <div style={{ padding: 0 }}>
                                <div
                                  className="d-flex justify-content-between align-items-center gap-2 mt-0"
                                  style={{
                                    padding: "0.5rem 0",
                                  }}
                                >
                                  <div className="pagination-left">
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "14px",
                                        paddingRight: "10rem",
                                      }}
                                    >
                                      Showing {offset + 1} of {pageCount !== 0 ? pageCount : pageCount + 1}
                                    </p>
                                  </div>
                                  <div className="pagination-right d-flex gap-2 align-items-center">
                                    <select
                                      style={{ minWidth: "78px", height: "2.3rem" }}
                                      onChange={(e) => {
                                        setLimit(Number(e.target.value));
                                        setOffset(0);
                                      }}
                                      id="limit"
                                      className="form-control form-select"
                                    >
                                      <option value={25}>25</option>
                                      <option value={100}>100</option>
                                      <option value={200}>200</option>
                                      <option value={300}>300</option>
                                    </select>
                                    <div className="d-flex align-items-center gap-3">
                                      <Pagination
                                        offset={offset}
                                        setOffset={setOffset}
                                        handlePageChange={handlePageChange}
                                        pageCount={pageCount}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </Table>
              </div>
              {allSalesOrder?.length <= 10 && (
                <div
                  style={{
                    padding: "0.5rem 0",
                    backgroundColor: "white",
                    borderTop: "1px solid #e0e0e0",
                    width: "100%",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center gap-2">
                    <div className="pagination-left">
                      <p className="mb-0" style={{ fontSize: "14px" }}>
                        Showing {offset + 1} of {pageCount !== 0
                          ? pageCount
                          : pageCount + 1}
                      </p>
                    </div>
                    <div className="pagination-right d-flex gap-2 align-items-center">
                      <select
                        style={{ minWidth: "78px", height: "2.3rem" }}
                        onChange={(e) => {
                          setLimit(Number(e.target.value));
                          setOffset(0);
                        }}
                        id="limit"
                        className="form-control form-select"
                      >
                        <option value={25}>25</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={300}>300</option>
                      </select>
                      <div className="d-flex align-items-center gap-3">
                        <Pagination
                          offset={offset}
                          setOffset={setOffset}
                          handlePageChange={handlePageChange}
                          pageCount={pageCount}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {showModal && (
              <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Cancel Sales Order</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <>
                    <p>Are you sure you want to cancel the sales order?</p>
                    <Form.Group controlId="rejectReason">
                      <Form.Label>Reason</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                      />
                    </Form.Group>
                  </>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="btn btn-default-outline me-2"
                    onClick={handleCloseModal}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn btn-default"
                    onClick={handleConfirm}
                    disabled={rejectReason.trim() === ""}
                  >
                    {loading ? "submiting.." : "Confirm"}
                  </Button>
                </Modal.Footer>
              </Modal>
            )}
          </Container>
          :
          <AuthorizationCard></AuthorizationCard>
      }
    </>
  );
};
